import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import type { Language, Localized } from '../types/content';
interface LanguageContextValue {
  lang: Language;
  setLang: (lang: Language) => void;
  toggleLang: () => void;
  t: (value: Localized) => string;
}
const LanguageContext = createContext<LanguageContextValue | null>(null);
interface LanguageProviderProps {
  initialLanguage?: Language;
  children: React.ReactNode;
}
export function LanguageProvider({
  initialLanguage = 'en',
  children
}: LanguageProviderProps) {
  const [lang, setLang] = useState<Language>(initialLanguage);
  const t = useCallback((value: Localized) => value[lang], [lang]);
  const toggleLang = useCallback(() => {
    setLang(current => current === 'en' ? 'es' : 'en');
  }, []);
  const value = useMemo<LanguageContextValue>(() => ({
    lang,
    setLang,
    toggleLang,
    t
  }), [lang, toggleLang, t]);
  return <LanguageContext.Provider value={value} data-id="element-366" data-mp="2jkf8guwgmw1d">{children}</LanguageContext.Provider>;
}
export function useLanguage(): LanguageContextValue {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
}